import moment from 'moment';
import { Col, Row } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const ReportConfigDetails = ({
    selectedQuarter, setSelectedQuarter, summaryQuartersData, commonData, displayColumn,
    istopier, rule,
}) => (
    <div>
        <Row style={{ marginTop: '1.5rem' }}>
            <Col md={6}>
                {selectedQuarter && displayColumn === 'Yes' && (
                    <Row>
                        {rule !== 'Metro2' && (
                            <>
                                <Col md={3} className="a-h6">
                                    Quarter
                                    <span className="label">:</span>
                                </Col>
                                <Col md={8}>
                                    <DatePicker
                                        selected={selectedQuarter}
                                        onChange={date => setSelectedQuarter(date)}
                                        dateFormat="yyyy, QQQ"
                                        showQuarterYearPicker
                                    />
                                </Col>
                            </>
                        )}
                        {rule === 'Metro2' && (
                            <>
                                <Col md={3} className="a-h6">
                                    Period
                                    <span className="label">:</span>
                                </Col>
                                <Col md={8}>
                                    <DatePicker
                                        selected={selectedQuarter}
                                        onChange={date => setSelectedQuarter(date)}
                                        dateFormat="MM/yyyy"
                                        showMonthYearPicker
                                    />
                                </Col>
                            </>
                        )}
                    </Row>
                )}
                {istopier && istopier === 'Yes' && (
                    <Row className="row-margin">
                        <Col md={3} className="a-h6">
                            Is toptier
                            <span className="label">:</span>
                        </Col>
                        <Col md={8}>
                            {commonData && commonData[0].isTopTier}
                        </Col>
                    </Row>
                )}
                <Row className="row-margin">
                    <Col md={3} className="a-h6">
                        Batch
                        <span className="label">:</span>
                    </Col>
                    <Col md={8}>
                        {commonData && (commonData[0] || []).batchId}
                    </Col>
                </Row>
                <Row className="row-margin">
                    <Col md={3} className="a-h6">
                        Status
                        <span className="label">:</span>
                    </Col>
                    <Col md={8}>
                        {commonData && (commonData[0] || []).batchRunStatus}
                    </Col>
                </Row>
                <Row className="row-margin" style={{ paddingBottom: '1.5rem' }}>
                    <Col md={3} className="a-h6">
                        Batch Date
                        <span className="label">:</span>
                    </Col>
                    <Col md={8}>
                        {commonData && commonData.length > 0 ? moment(commonData[0].batchStartTime).format('MM-DD-YYYY') : ''}
                    </Col>
                </Row>
            </Col>
            <Col md={6}>
                <Row className="row-margin">
                    <Col md={3} className="a-h6">
                        File Loaded
                        <span className="label">:</span>
                    </Col>
                    <Col md={8}>
                        {commonData && (commonData[0] || []).fileName}
                    </Col>
                </Row>
                <Row className="row-margin" style={{ paddingBottom: '1.5rem' }}>
                    <Col md={3} className="a-h6">
                        Total Records
                        <span className="label">:</span>
                    </Col>
                    <Col md={8}>
                        {commonData && (commonData[0] || []).totalRecords}
                    </Col>
                </Row>
            </Col>
        </Row>
    </div>
);

export default ReportConfigDetails;
